export default function loadBMapGL() {
  // 公司ak，域名限定，李伟名下
  // const ak = 'pEbgIZWxuko4XcGg8f6Xa45Ky7oud49C'

  // 开发ak，域名不限定，姜少辉名下
  const ak = 'XsGpAZGnYbzGaf8j1WHCz4Ir'
  return new Promise(function(resolve, reject) {
    window.init = function() {
      // eslint-disable-next-line
      resolve(BMapGL)
    }
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = `http://api.map.baidu.com/api?v=1.0&type=webgl&ak=${ak}&callback=init`
    script.onerror = reject
    document.head.appendChild(script)
  })
}



// WEBPACK FOOTER //
// ./src/common/BMapGL.js